var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBsWorkspaceDirectory = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 27,
  height: 27,
  viewBox: "0 0 27 27",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M23.997 3A3 3 0 0 1 27 6.003v17.994A3 3 0 0 1 23.997 27H6.003A3 3 0 0 1 3 23.997V12h3v10.997C6 23.552 6.448 24 7.003 24h15.994c.555 0 1.003-.448 1.003-1.003V7.003C24 6.448 23.552 6 22.997 6H12V3ZM6 0v3h3v3H6v3H3V6H0V3h3V0z"
})));
export default SvgBsWorkspaceDirectory;